import { useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { useHistory, useLocation } from 'react-router-dom';


export const roots = ["C", "Db", "D", "Eb", "E", "F", "Gb", "G", "Ab", "A", "Bb", "B"];
export const defaultOctaveMidiNote = 48;

/**
 * Normalize a number between two ranges
 * @param  {float} val    value to normalize
 * @param  {float} minVal minimum
 * @param  {float} maxVal maximum
 * @param  {float} newMin new minumim
 * @param  {float} newMax new maximum
 * @return {float}        normalized value
 */
export const normalizeBetweenTwoRanges = (val, minVal, maxVal, newMin, newMax) => {
  return parseFloat(newMin + (val - minVal) * (newMax - newMin) / (maxVal - minVal));
};

/**
 * Transpose a note
 * @param  {String} note      The note to transpose
 * @param  {Number} transpose The amount to transpose
 * @return {String}           The transposed note
 */
export const transpose = (note, transpose) => {
  let transposed;
  if (typeof note === 'string') {
    let octave = parseInt(note.charAt(note.length - 1));
    octave += transpose;
    octave = Math.max(0, octave);
    const root = note.substring(0, note.length-1);
    transposed = root + octave;
  } else if (typeof note === 'number') {

  }
  return transposed
};

/**
 * Name to a note
 * @param  {String} s The note name
 * @return {Number}   The note in numerical form
 */
export const nameToNote = ( s ) => {
  var c, i, d;
  if ( s.length === 2 ) s = s[ 0 ] + ' ' + s[ 1 ];
  if ( s.length !== 3 ) throw new Error( 'Invalid note name' );
  s = s.toUpperCase();
  c = -1;

  d = s[ 0 ] + s[ 1 ];
  for ( i = 0; i < 12; i++ ){
    if (roots[ i ] === d ){
      c = i;
      break;
    }
  }
  i = parseInt( s[ 2 ] );
  return i * 12 + c;
};

/**
 * Note to name
 * @param  {Number} n The note in numerical form
 * @return {String}   The note as a name
 */
export const noteToName = ( n ) => {
  if ( n >= 0 && n <= 127 ){
    return ( roots[ n % 12 ] + Math.floor( n / 12 ) ).replace(/[ ]+/gi,'');
  } else {
    throw new Error( 'note value out of range (' + n + ')' );
  }
};

/**
 * A stupid log
 */
export const stupidLog = () => {
  console.log('bajs');
};

/**
 * Redirect by checking out cookies
 */
export const CookieRedirect = () => {
  // eslint-disable-next-line
  const location = useLocation();
  // History
  const history = useHistory();
  // Cookies
  const [cookie, removeCookie] = useCookies(['tooYoung', 'hasSeenIntro']);
  /**
   * Age gate: redirect if already said under 13
   */
  useEffect(() => {
    if (window.location.search.indexOf('resetCookie') !== -1) {
      removeCookie('tooYoung');
      removeCookie('hasSeenIntro');
      history.push('/');
    } else {
      // If we haven't set the cookies...
      // This is messed up atm, commenting out for now
      // if ((cookie.tooYoung === undefined) ||
      //   (cookie.loggedIn === undefined)) {
      //   // and we're already at the main screen
      //   if (location.pathname === '/main') {
      //     // go back to the home screen and ask their age
      //     history.push('/');
      //   }
      // }
      // Otherwise, if we have a user that is too young,
      // we send them to the age gate
      if (cookie.tooYoung === 'true') {
        history.push('/not-available');
      }
    } // eslint-disable-next-line
  }, []);
};

/**
 * Screen Adjustments
 *
 * Mobile hacks to try and get full screen,
 * and get proper VH units
 */
export const ScreenAdjustments = () => {
  useEffect(() => {
    /**
     * Go into full screen (or try)
     * and set proper VH units
     */
    const goFullScreenAndSetUnits = (e) => {
      setTimeout(() => {
        window.scrollTo(0, 1);
        // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
        let vw = document.documentElement.clientWidth * 0.01;
        let vh = document.documentElement.clientHeight * 0.01;
        // Then we set the value in the --vh custom property to the root of the document
        document.documentElement.style.setProperty('--vw', `${vw}px`);
        document.documentElement.style.setProperty('--vh', `${vh}px`);
      }, 500);
    };
    // Listeners for full screen
    window.addEventListener('resize', goFullScreenAndSetUnits);
    goFullScreenAndSetUnits();
    return () => {
      // Remove listeners for full screen
      window.removeEventListener('resize', goFullScreenAndSetUnits);
    }
  }, []);
};

/**
 * Get the average of an array of numbers
 * @param  {array}  arr [the array of numbers to average]
 * @return {number}     [the average]
 */
export const ArrayAvg = (arr) => {
  return arr.reduce((a, b) => a + b)/arr.length;
};

/**
 * Linear interpolation
 * @param  {number} v0 [lower bound]
 * @param  {number} v1 [upper bound]
 * @param  {number} t  [value between 0 and 1]
 * @return {number}    [interpolated value]
 */
export const Lerp = (v0, v1, t) => {
  return v0*(1-t)+v1*t;
};

/**
 * Clamp
 * @param  {number} min [minimum number]
 * @param  {number} max [maximum number]
 * @param  {number} num [number to clamp]
 * @return {number}     [clamped number]
 */
export const Clamp = (min, max, num) => {
  return Math.min(Math.max(num, min), max);
};
